import axios from 'axios';

const api = axios.create({
  // baseURL: 'http://localhost:5000/api',
   baseURL: process.env.REACT_APP_API_URL || 'https://api.zevazeva.com/api',
  timeout: 15000,
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  async err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
